import { Box, CircularProgress, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export type PageLoadingStateVariant = "centered" | "inline";

export interface PageLoadingStateProps {
  message?: string;
  size?: number;
  minHeight?: number | string;
  variant?: PageLoadingStateVariant;
  sx?: SxProps<Theme>;
}

export function PageLoadingState({
  message = "Loading…",
  size = 18,
  minHeight = 400,
  variant = "inline",
  sx,
}: PageLoadingStateProps) {
  if (variant === "centered") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.25,
          minHeight,
          ...sx,
        }}
      >
        <CircularProgress size={Math.max(24, size)} />
        {message ? <Typography variant="body2">{message}</Typography> : null}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        ...sx,
      }}
    >
      <CircularProgress size={size} />
      {message ? <Typography variant="body2">{message}</Typography> : null}
    </Box>
  );
}
